import { lazy } from 'react';
import { useRoutes } from 'react-router-dom';

// project imports
import PublicLayout from 'views/layouts/PublicLayout/Home'; // Your main layout with header/footer
import MinimalLayout from 'views/layouts/MinimalLayout';  // A layout for pages without a header/footer
import Loadable from 'components/common/Loadable';

// Lazy load all your pages for better performance
const HomePage = Loadable(lazy(() => import('views/pages/home/homePage')));
const Careers = Loadable(lazy(() => import('views/pages/Careers/Careers')));
const Contact = Loadable(lazy(() => import('views/pages/Contact/Contact')));

export default function ThemeRoutes() {
    return useRoutes([
        // --- Group 1: All main public routes that use the PublicLayout ---
        {
            path: '/',
            element: <PublicLayout />, // This layout MUST contain your <ThemeProvider>
            children: [
                {
                    path: '/',
                    element: <HomePage />
                },
                {
                    path: 'home',
                    element: <HomePage />
                },
                {
                    path: 'careers',
                    element: <Careers />
                },
                {
                    path: 'contact',
                    element: <Contact />
                }
                // Add any other public pages that need a header and footer here
            ]
        },

        // --- Group 2: Routes that use a different, minimal layout ---
        {
            path: '/',
            element: <MinimalLayout />,
            children: [
                // You can add other simple pages like '404' or other minimal layout pages here
            ]
        }
    ]);
}